import React, { useState, useEffect } from 'react';

export const StepFour = (props) => {

    const [data, setData] = useState({
        penalities: props.data.penalities,
        place: props.data.place,
        cost: props.data.cost,
        detail: props.data.detail,
    })

    const handleChange = (prop, value) => {
        setData((prevState) => ({
            ...prevState,
            [prop]: value, 
        }));
    }

    useEffect((props) => { 
        props.updateStepData('four', data)
    }, [data])


    const checkValue = (id) => {
        if(data.penalities.find((penalitie) => penalitie.id === id)) {
            return true;
        }
        return false;
    }

    const setValue = (item) => {
       if(data.penalities.find((penalitie) => penalitie.id === item.id)) {
            const newPenalities = data.penalities.filter((penalitie) => penalitie.id !== item.id)
            handleChange('penalities', newPenalities)
       }else{
            const newPenalities = [...data.penalities, item]
            handleChange('penalities', newPenalities)
       }
    }

    return(
            <div style={{padding:50}}>
                <div className="mt-6 border-t border-gray-100">
                    <dl className="divide-y divide-gray-100">
                        <div>
                            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                Seleccione Sanciones a asignar
                            </label>
                            <div style={{marginTop:10}}>
                                {
                                    props.penalities.map((penalitie) => {
                                        return(
                                            <fieldset>
                                                <div className="space-y-5">
                                                    <div className="relative flex items-start">
                                                        <div className="flex h-6 items-center">
                                                            <input
                                                                style={{marginTop:40}}
                                                                onChange={() => setValue(penalitie) }
                                                                value={checkValue(penalitie.id)}
                                                                id="comments"
                                                                name="comments"
                                                                type="checkbox"
                                                                aria-describedby="comments-description"
                                                                className="size-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                                            />
                                                        </div>
                                                        <div className="ml-3 text-sm/6">
                                                            <label htmlFor="comments" className="font-medium text-gray-900">                                                               
                                                                <p>{penalitie.concept}</p>
                                                                <p style={{color:'gray'}}>Articulo: {penalitie.art}  </p>
                                                                <p style={{color:'gray'}}>Numeral: {penalitie.numeral}</p>                                                        
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr/>
                                            </fieldset>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </dl>
                </div>
            </div>
    )
}